import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import defaultBgImage from '../../assets/images/png/ac-splash-full.jpg';
@inject('configurationsStore') @observer
export default class LoginBanner extends Component {
    
    customUrl = '/images/cx-background.jpg'

    getBgImageUrl = () => {
        return this.props.configurationsStore.isMultitenancyMode === false ? 
            'url(' + this.customUrl + '), url(' + defaultBgImage + ')' : 'url(' + defaultBgImage + ')';
    }

    bgStyle = {
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundImage: this.getBgImageUrl()
    };

    render() { 
        return <div className='wrapper-right' style={this.bgStyle}> </div>;
    }
}